export const en = {
  'deskPanel.clearSelection': 'Clear selection',
  'deskPanel.pendingPayments.one': '{count} pending payment',
  'deskPanel.pendingPayments.other': '{count} pending payments',
  'deskPanel.visitsToday.one': '{count} visit today',
  'deskPanel.visitsToday.other': '{count} visits today',
  'deskPanel.lastVisit': 'last visit {when}',
  'deskPanel.lastVisitNever': 'last visit never',
  'deskPanel.entryDenied': 'Entry denied',
  'deskPanel.entryAllowedByStaff': 'Entry allowed by staff',
  'deskPanel.checkedIn': 'Checked in',
  'deskPanel.visitNumber': 'Visit {count} today',
  'deskPanel.visitNumberInline': 'visit {count} today',
  'deskPanel.membershipEnds': 'membership ends {date}',
  'deskPanel.allowAnyway': 'Allow anyway',
  'deskPanel.checkIn': 'Check in',
  'deskPanel.openTurnstile': 'Open turnstile',
  'deskPanel.openTurnstileDescription': 'Sends a remote-open command and records an access event for {name}.',
  'deskPanel.openNow': 'Open now',
  'deskPanel.tab.memberships': 'Memberships ({count})',
  'deskPanel.tab.cards': 'Cards ({count})',
  'deskPanel.tab.bookings': 'Today’s bookings ({count})',
  'deskPanel.tab.visits': 'Recent visits ({count})',
  'deskPanel.openProfile': 'Open full profile',
  'deskPanel.noMemberships': 'No memberships yet. Sell a plan to give this member access.',
  'deskPanel.packs': 'Session and class packs',
  'deskPanel.packSummary': '{left} of {total} left · use by {date}',
  'deskPanel.autoRenew': 'auto-renew',
  'deskPanel.noCards': 'No cards or codes assigned. Use “Assign card” after scanning a new card.',
  'deskPanel.lastUsed': 'last used {when}',
  'deskPanel.neverUsed': 'never used',
  'deskPanel.noBookings': 'No classes booked for today.',
  'deskPanel.waitlistPosition': 'waitlist #{position}',
  'deskPanel.noVisits': 'No access events recorded for this member.',
  'deskPanel.frontDesk': 'Front desk',
  'deskPanel.reader': 'Reader',
  'deskPanel.override.title': 'Allow entry anyway?',
  'deskPanel.override.description': 'The door would deny {name}: {reason}. The override is recorded with your name.',
  'deskPanel.override.placeholder': 'e.g. paying at the desk after the workout',
  'deskPanel.override.confirm': 'Allow entry',
  'deskPanel.login.title': 'Member login',
  'deskPanel.login.none': 'No login',
  'deskPanel.login.pending': 'Password not set',
  'deskPanel.login.waiting': 'Waiting for confirmation',
  'deskPanel.login.active': 'Can sign in',
  'deskPanel.login.activeDetail': 'Signs in to the member area with their own password',
  'deskPanel.login.waitingDetail': 'Waiting for the account holder to confirm. {summary}',
  'deskPanel.login.cannotSignIn': 'Cannot sign in to the member area',
  'deskPanel.login.willEmail': "We'll email {email} a link to set their password",
  'deskPanel.login.addEmail': 'Add an email in the full profile to create one',
  'deskPanel.login.create': 'Create a login',
  'deskPanel.login.resendInvitation': 'Resend invitation',
  'deskPanel.login.resend': 'Resend',
  'sell.title': 'Sell membership',
  'sell.description': 'Records a desk payment and activates the plan straight away.',
  'sell.active': 'The membership is active.',
  'sell.created': 'The member was created and their membership is active.',
  'sell.createdInvited': 'The member was created and their membership is active. We emailed {email} a link to set their password.',
  'sell.createdInvitedNoEmail': 'The member was created and their membership is active. We emailed them a link to set their password.',
  'sell.createdConfirm': 'The member was created and their membership is active. {email} already has an account, so we emailed its holder to confirm before it is linked.',
  'sell.createdConfirmNoEmail': 'The member was created and their membership is active. The email already has an account, so we emailed its holder to confirm before it is linked.',
  'sell.planRequired': 'Choose a plan',
  'sell.firstNameRequired': 'First name is required',
  'sell.lastNameRequired': 'Last name is required',
  'sell.invalidEmail': 'Enter a valid email address',
  'sell.sold': 'Sold {plan}',
  'sell.soldWithReceipt': 'Sold {plan} · receipt {receipt}',
  'sell.pickMember': 'Pick the member who is buying',
  'sell.complete': 'Sale complete',
  'sell.viewReceipt': 'View receipt',
  'sell.printReceipt': 'Print receipt',
  'sell.sellFor': 'Sell for {price}',
  'sell.sell': 'Sell',
  'sell.whoIsBuying': 'Who is buying',
  'sell.existingMember': 'Existing member',
  'sell.newMember': 'New member',
  'sell.gender': 'Gender',
  'sell.loginHint': "We'll email a link to set their password",
  'sell.loginNeedsEmail': 'Add an email to create a login',
  'sell.member': 'Member',
  'sell.plan': 'Plan',
  'sell.starts': 'Starts',
  'sell.startsHint': 'Leave empty to start now, or when a running membership of the same plan ends',
  'sell.startsLater': 'Starts {date}: until then they cannot come in or book classes.',
  'sell.paidBy': 'Paid by',
  'sell.card': 'Card',
  'sell.cardHint': 'optional, scan it now to assign it in the same step',
  'sell.scanCard': 'Scan the card',
  'sell.labelPlaceholder': 'Blue card',
  'sell.noteHint': 'Optional, printed on the receipt',
  'sell.termsAccepted': 'The member accepted the current {documents} at the desk.',
  'sell.termsHint': 'Recorded against the published version, the same as an online acceptance.',
  'sell.receipt': 'Receipt {number}',
  'sell.period': 'Period',
  'sell.amount': 'Amount',
  'sell.paidAt': 'Paid at',
  'sell.accepted': 'Accepted',
  'shift.cashDrawer': 'Cash drawer',
  'shift.barDrawer': 'Bar cash drawer',
  'shift.isOpen': 'Shift open',
  'shift.isClosed': 'Closed',
  'shift.since': 'Since {time}',
  'shift.float': 'Float {amount}',
  'shift.expectedInDrawer': 'Expected in drawer {amount}',
  'shift.blocked': 'Cash sales are blocked until a shift is opened.',
  'shift.openHint': 'Open a shift to reconcile the drawer at the end of the day.',
  'shift.openShift': 'Open shift',
  'shift.closeShift': 'Close shift',
  'shift.opened': 'Shift opened',
  'shift.closed': 'Shift closed',
  'shift.openDescription': 'Count the cash in the drawer before the first sale.',
  'shift.floatRequired': 'Enter the cash in the drawer, 0 if it is empty',
  'shift.openingFloatIn': 'Opening float ({currency})',
  'shift.closeDescription': 'Count every note and coin in the drawer, including the float. The expected amount is shown after you submit.',
  'shift.countedRequired': 'Enter the cash you counted',
  'shift.countedCashIn': 'Counted cash ({currency})',
  'shift.noteHint': 'Optional, for example why the drawer is short',
  'shift.closedDescription': 'The count is stored with the expected amount for the daily report.',
  'shift.done': 'Done',
  'shift.openingFloat': 'Opening float',
  'shift.cashSales': 'Cash sales',
  'shift.cashRefunds': 'Cash refunds',
  'shift.cashPaidOut': 'Paid out',
  'shift.payout.heading': 'Paid out this shift',
  'shift.payout.button': 'Pay out',
  'shift.payout.none': 'Nothing paid out of this drawer yet.',
  'shift.payout.title': 'Pay out of the drawer',
  'shift.payout.description': 'Cash taken from this drawer for an expense. The shift will expect this much less cash when you count it.',
  'shift.payout.amountIn': 'Amount ({currency})',
  'shift.payout.submit': 'Pay out',
  'shift.payout.done': 'Payout recorded',
  'shift.payout.voided': 'Voided',
  'shift.expected': 'Expected',
  'shift.counted': 'Counted',
  'shift.difference': 'Difference',
  'shift.balanced': 'Balanced',
  'shift.short': 'Short {amount}',
  'shift.over': 'Over {amount}',
  'assignCard.title': 'Assign card',
  'assignCard.description': 'Tap the new card on the desk reader (or type its number). Once assigned it opens the door for {name}.',
  'assignCard.assigned': '{type} assigned to {name}',
  'assignCard.assign': 'Assign',
  'assignCard.value': 'Value',
  'assignCard.valueHint': 'Card UID, QR payload or PIN. Tap the card on the reader to fill this, then press Assign.',
  'assignCard.valuePlaceholder': 'Tap the card on the reader',
  'assignCard.type': 'Type',
  'assignCard.label': 'Label',
  'assignCard.labelHint': 'Optional, e.g. “Blue card”',
  'bookClass.title': 'Book a class',
  'bookClass.unavailable': 'Cannot be booked for this member.',
  'bookClass.description': 'Today’s remaining sessions for {name}.',
  'bookClass.booked': '{name} booked into {className} at {time}',
  'bookClass.waitlisted': '{name} is on the waitlist for {className}',
  'bookClass.waitlistedAt': '{name} is on the waitlist for {className} (#{position})',
  'bookClass.joinWaitlist': 'Join waitlist',
  'bookClass.book': 'Book',
  'bookClass.noneLeft': 'No more classes today',
  'bookClass.noneLeftHint': 'All of today’s sessions have started or were cancelled.',
  'bookClass.sessions': 'Sessions',
  'bookClass.alreadyBooked': 'already booked',
  'bookClass.fullWaiting': 'full · {count} waiting',
  'bookClass.spotsLeft': '{left} of {capacity} spots left',
  'bookClass.usesClassPack': 'Uses one visit from a class pack.',
  'print.atDesk': 'Print at desk',
  'print.printOn': 'Print on {printer}',
  'print.agentOffline': 'The on-site agent is offline',
  'print.printed': 'Printed on {printer}',
  'print.failed': 'Printing failed',
  'print.notAccepted': 'The printer did not accept the receipt',
  'print.stillWaiting': 'Still waiting for the printer',
  'print.notPickedUp': 'The on-site agent has not picked the receipt up yet; it prints when it does.',
};

export const ka: Record<keyof typeof en, string> = {
  'deskPanel.clearSelection': 'არჩევის გაუქმება',
  'deskPanel.pendingPayments.one': '{count} გადახდა მოლოდინში',
  'deskPanel.pendingPayments.other': '{count} გადახდა მოლოდინში',
  'deskPanel.visitsToday.one': 'დღეს {count} ვიზიტი',
  'deskPanel.visitsToday.other': 'დღეს {count} ვიზიტი',
  'deskPanel.lastVisit': 'ბოლო ვიზიტი {when}',
  'deskPanel.lastVisitNever': 'ჯერ არ მოსულა',
  'deskPanel.entryDenied': 'შესვლა უარყოფილია',
  'deskPanel.entryAllowedByStaff': 'შესვლა დაუშვა თანამშრომელმა',
  'deskPanel.checkedIn': 'შემოშვებულია',
  'deskPanel.visitNumber': 'დღევანდელი ვიზიტი #{count}',
  'deskPanel.visitNumberInline': 'დღევანდელი ვიზიტი #{count}',
  'deskPanel.membershipEnds': 'აბონემენტი მთავრდება {date}',
  'deskPanel.allowAnyway': 'მაინც შეშვება',
  'deskPanel.checkIn': 'შემოშვება',
  'deskPanel.openTurnstile': 'ტურნიკეტის გაღება',
  'deskPanel.openTurnstileDescription': 'აგზავნის დისტანციური გაღების ბრძანებას და შესვლას აღრიცხავს წევრზე: {name}.',
  'deskPanel.openNow': 'ახლავე გაღება',
  'deskPanel.tab.memberships': 'აბონემენტები ({count})',
  'deskPanel.tab.cards': 'ბარათები ({count})',
  'deskPanel.tab.bookings': 'დღევანდელი ჯავშნები ({count})',
  'deskPanel.tab.visits': 'ბოლო ვიზიტები ({count})',
  'deskPanel.openProfile': 'სრული პროფილის გახსნა',
  'deskPanel.noMemberships': 'აბონემენტი ჯერ არ აქვს. მიჰყიდეთ პაკეტი, რომ დარბაზში შესვლა შეძლოს.',
  'deskPanel.packs': 'სესიებისა და ჯგუფური ვარჯიშების პაკეტები',
  'deskPanel.packSummary': 'დარჩა {left} / {total} · გამოიყენეთ {date}-მდე',
  'deskPanel.autoRenew': 'ავტომატური გაგრძელება',
  'deskPanel.noCards': 'ბარათები და კოდები მიბმული არ არის. ახალი ბარათის დასკანერების შემდეგ გამოიყენეთ „ბარათის მიბმა“.',
  'deskPanel.lastUsed': 'ბოლოს გამოყენდა {when}',
  'deskPanel.neverUsed': 'ჯერ არ გამოყენებულა',
  'deskPanel.noBookings': 'დღეისთვის ვარჯიშზე ჩაწერილი არ არის.',
  'deskPanel.waitlistPosition': 'მოლოდინის სიაში #{position}',
  'deskPanel.noVisits': 'ამ წევრის შესვლები ჯერ არ დაფიქსირებულა.',
  'deskPanel.frontDesk': 'მიმღები',
  'deskPanel.reader': 'წამკითხველი',
  'deskPanel.override.title': 'შესვლა მაინც დავუშვათ?',
  'deskPanel.override.description': 'კარი არ შეუშვებდა წევრს {name}: {reason}. გამონაკლისი თქვენი სახელით აღირიცხება.',
  'deskPanel.override.placeholder': 'მაგ. ვარჯიშის შემდეგ გადაიხდის მიმღებთან',
  'deskPanel.override.confirm': 'შესვლის დაშვება',
  'deskPanel.login.title': 'წევრის ანგარიში',
  'deskPanel.login.none': 'ანგარიში არ აქვს',
  'deskPanel.login.pending': 'პაროლი არ არის დაყენებული',
  'deskPanel.login.waiting': 'ელოდება დადასტურებას',
  'deskPanel.login.active': 'შესვლა შეუძლია',
  'deskPanel.login.activeDetail': 'წევრის კაბინეტში საკუთარი პაროლით შედის',
  'deskPanel.login.waitingDetail': 'ელოდება ანგარიშის მფლობელის დადასტურებას. {summary}',
  'deskPanel.login.cannotSignIn': 'წევრის კაბინეტში შესვლა არ შეუძლია',
  'deskPanel.login.willEmail': 'მისამართზე {email} გავგზავნით ბმულს პაროლის დასაყენებლად',
  'deskPanel.login.addEmail': 'ანგარიშის შესაქმნელად სრულ პროფილში დაამატეთ ელფოსტა',
  'deskPanel.login.create': 'ანგარიშის შექმნა',
  'deskPanel.login.resendInvitation': 'მოწვევის ხელახლა გაგზავნა',
  'deskPanel.login.resend': 'ხელახლა გაგზავნა',
  'sell.title': 'აბონემენტის გაყიდვა',
  'sell.description': 'აღრიცხავს მიმღებთან გადახდას და პაკეტს მაშინვე ააქტიურებს.',
  'sell.active': 'აბონემენტი აქტიურია.',
  'sell.created': 'წევრი შეიქმნა და აბონემენტი აქტიურია.',
  'sell.createdInvited': 'წევრი შეიქმნა და აბონემენტი აქტიურია. მისამართზე {email} გავგზავნეთ ბმული პაროლის დასაყენებლად.',
  'sell.createdInvitedNoEmail': 'წევრი შეიქმნა და აბონემენტი აქტიურია. წევრს ელფოსტით გავუგზავნეთ ბმული პაროლის დასაყენებლად.',
  'sell.createdConfirm': 'წევრი შეიქმნა და აბონემენტი აქტიურია. ელფოსტით {email} ანგარიში უკვე არსებობს, ამიტომ მის მფლობელს დასადასტურებლად მივწერეთ, სანამ ანგარიშს მივაბამთ.',
  'sell.createdConfirmNoEmail': 'წევრი შეიქმნა და აბონემენტი აქტიურია. ამ ელფოსტით ანგარიში უკვე არსებობს, ამიტომ მის მფლობელს დასადასტურებლად მივწერეთ, სანამ ანგარიშს მივაბამთ.',
  'sell.planRequired': 'აირჩიეთ პაკეტი',
  'sell.firstNameRequired': 'სახელი სავალდებულოა',
  'sell.lastNameRequired': 'გვარი სავალდებულოა',
  'sell.invalidEmail': 'შეიყვანეთ სწორი ელფოსტის მისამართი',
  'sell.sold': 'გაიყიდა: {plan}',
  'sell.soldWithReceipt': 'გაიყიდა: {plan} · ქვითარი {receipt}',
  'sell.pickMember': 'აირჩიეთ წევრი, რომელიც ყიდულობს',
  'sell.complete': 'გაყიდვა დასრულდა',
  'sell.viewReceipt': 'ქვითრის ნახვა',
  'sell.printReceipt': 'ქვითრის ბეჭდვა',
  'sell.sellFor': 'გაყიდვა · {price}',
  'sell.sell': 'გაყიდვა',
  'sell.whoIsBuying': 'ვინ ყიდულობს',
  'sell.existingMember': 'არსებული წევრი',
  'sell.newMember': 'ახალი წევრი',
  'sell.gender': 'სქესი',
  'sell.loginHint': 'ელფოსტით გავუგზავნით ბმულს პაროლის დასაყენებლად',
  'sell.loginNeedsEmail': 'ანგარიშის შესაქმნელად მიუთითეთ ელფოსტა',
  'sell.member': 'წევრი',
  'sell.plan': 'პაკეტი',
  'sell.starts': 'დაწყების თარიღი',
  'sell.startsHint': 'დატოვეთ ცარიელი, რომ დაიწყოს ახლავე ან მაშინ, როცა იმავე პაკეტის მიმდინარე აბონემენტი დასრულდება',
  'sell.startsLater': 'იწყება {date}-ს: მანამდე დარბაზში შესვლა და ვარჯიშებზე ჩაწერა არ შეეძლებათ.',
  'sell.paidBy': 'გადახდის მეთოდი',
  'sell.card': 'ბარათი',
  'sell.cardHint': 'არასავალდებულო, დაასკანერეთ ახლავე, რომ იმავე ნაბიჯში მიებას',
  'sell.scanCard': 'დაასკანერეთ ბარათი',
  'sell.labelPlaceholder': 'ლურჯი ბარათი',
  'sell.noteHint': 'არასავალდებულო, იბეჭდება ქვითარზე',
  'sell.termsAccepted': 'წევრმა მიმღებთან მიიღო მოქმედი დოკუმენტები: {documents}.',
  'sell.termsHint': 'აღირიცხება გამოქვეყნებულ ვერსიაზე, ისევე როგორც ონლაინ თანხმობა.',
  'sell.receipt': 'ქვითარი {number}',
  'sell.period': 'პერიოდი',
  'sell.amount': 'თანხა',
  'sell.paidAt': 'გადახდის დრო',
  'sell.accepted': 'მიღებული დოკუმენტები',
  'shift.cashDrawer': 'სალარო',
  'shift.barDrawer': 'ბარის სალარო',
  'shift.isOpen': 'ცვლა ღიაა',
  'shift.isClosed': 'დახურულია',
  'shift.since': '{time}-დან',
  'shift.float': 'საწყისი თანხა {amount}',
  'shift.expectedInDrawer': 'სალაროში უნდა იყოს {amount}',
  'shift.blocked': 'ნაღდი ფულით გაყიდვა დაბლოკილია, სანამ ცვლა არ გაიხსნება.',
  'shift.openHint': 'გახსენით ცვლა, რომ დღის ბოლოს სალარო შეაჯეროთ.',
  'shift.openShift': 'ცვლის გახსნა',
  'shift.closeShift': 'ცვლის დახურვა',
  'shift.opened': 'ცვლა გაიხსნა',
  'shift.closed': 'ცვლა დაიხურა',
  'shift.openDescription': 'პირველ გაყიდვამდე დათვალეთ სალაროში არსებული თანხა.',
  'shift.floatRequired': 'შეიყვანეთ სალაროში არსებული თანხა, ან 0, თუ სალარო ცარიელია',
  'shift.openingFloatIn': 'საწყისი თანხა ({currency})',
  'shift.closeDescription': 'დათვალეთ სალაროში ყველა კუპიურა და მონეტა, საწყისი თანხის ჩათვლით. მოსალოდნელი თანხა გამოჩნდება დადასტურების შემდეგ.',
  'shift.countedRequired': 'შეიყვანეთ დათვლილი თანხა',
  'shift.countedCashIn': 'დათვლილი თანხა ({currency})',
  'shift.noteHint': 'არასავალდებულო, მაგალითად, რატომ აკლია სალაროს თანხა',
  'shift.closedDescription': 'დათვლილი თანხა ინახება მოსალოდნელ თანხასთან ერთად დღის ანგარიშისთვის.',
  'shift.done': 'მზადაა',
  'shift.openingFloat': 'საწყისი თანხა',
  'shift.cashSales': 'ნაღდი გაყიდვები',
  'shift.cashRefunds': 'ნაღდი დაბრუნებები',
  'shift.cashPaidOut': 'გაცემული თანხა',
  'shift.payout.heading': 'ამ ცვლაში გაცემული თანხა',
  'shift.payout.button': 'თანხის გაცემა',
  'shift.payout.none': 'ამ სალაროდან ჯერ არაფერი გაცემულა.',
  'shift.payout.title': 'თანხის გაცემა სალაროდან',
  'shift.payout.description': 'ხარჯისთვის ამ სალაროდან აღებული ნაღდი ფული. ცვლის დათვლისას სალაროში ამდენით ნაკლები ნაღდი ფული იქნება მოსალოდნელი.',
  'shift.payout.amountIn': 'თანხა ({currency})',
  'shift.payout.submit': 'თანხის გაცემა',
  'shift.payout.done': 'გაცემა დაფიქსირდა',
  'shift.payout.voided': 'გაუქმებული',
  'shift.expected': 'მოსალოდნელი',
  'shift.counted': 'დათვლილი',
  'shift.difference': 'სხვაობა',
  'shift.balanced': 'სხვაობა არ არის',
  'shift.short': 'დანაკლისი {amount}',
  'shift.over': 'ზედმეტი {amount}',
  'assignCard.title': 'ბარათის მიბმა',
  'assignCard.description': 'მიადეთ ახალი ბარათი მიმღების წამკითხველს (ან აკრიფეთ მისი ნომერი). მიბმის შემდეგ ის კარს გაუღებს წევრს: {name}.',
  'assignCard.assigned': '{type} მიება წევრს: {name}',
  'assignCard.assign': 'მიბმა',
  'assignCard.value': 'ნომერი ან კოდი',
  'assignCard.valueHint': 'ბარათის UID, QR კოდის შიგთავსი ან PIN. ველის შესავსებად მიადეთ ბარათი წამკითხველს, შემდეგ დააჭირეთ ღილაკს „მიბმა“.',
  'assignCard.valuePlaceholder': 'მიადეთ ბარათი წამკითხველს',
  'assignCard.type': 'ტიპი',
  'assignCard.label': 'დასახელება',
  'assignCard.labelHint': 'არასავალდებულო, მაგ. „ლურჯი ბარათი“',
  'bookClass.title': 'ვარჯიშზე ჩაწერა',
  'bookClass.unavailable': 'ამ წევრისთვის ჩაწერა შეუძლებელია.',
  'bookClass.description': 'დღევანდელი დარჩენილი სესიები წევრისთვის: {name}.',
  'bookClass.booked': '{name} ჩაიწერა ვარჯიშზე „{className}“ {time}-ზე',
  'bookClass.waitlisted': '{name} მოლოდინის სიაშია ვარჯიშზე „{className}“',
  'bookClass.waitlistedAt': '{name} მოლოდინის სიაშია ვარჯიშზე „{className}“ (#{position})',
  'bookClass.joinWaitlist': 'მოლოდინის სიაში ჩაწერა',
  'bookClass.book': 'ჩაწერა',
  'bookClass.noneLeft': 'დღეს მეტი ვარჯიში აღარ არის',
  'bookClass.noneLeftHint': 'დღევანდელი ყველა სესია უკვე დაიწყო ან გაუქმდა.',
  'bookClass.sessions': 'სესიები',
  'bookClass.alreadyBooked': 'უკვე ჩაწერილია',
  'bookClass.fullWaiting': 'სავსეა · {count} ელოდება',
  'bookClass.spotsLeft': 'თავისუფალია {left} ადგილი {capacity}-დან',
  'bookClass.usesClassPack': 'ჩამოიწერება ჯგუფური ვარჯიშების პაკეტის ერთი ვიზიტი.',
  'print.atDesk': 'მიმღებთან ბეჭდვა',
  'print.printOn': 'ბეჭდვა პრინტერზე: {printer}',
  'print.agentOffline': 'ადგილობრივი აგენტი გათიშულია',
  'print.printed': 'დაიბეჭდა პრინტერზე: {printer}',
  'print.failed': 'ბეჭდვა ვერ მოხერხდა',
  'print.notAccepted': 'პრინტერმა ქვითარი არ მიიღო',
  'print.stillWaiting': 'პრინტერს ჯერ კიდევ ველოდებით',
  'print.notPickedUp': 'ადგილობრივ აგენტს ქვითარი ჯერ არ აუღია; დაიბეჭდება, როგორც კი აიღებს.',
};
